import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import {
  InquiryDetailModel,
  InquirySimpleModel,
  InquiryUpdateModel,
} from "@models/inquiry/inquiryModel"

class InquiryService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetAll", { params })
    const { result } = res.data
    return result
  }
  public async getListBookingById(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetListBookingById", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async getListContractById(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetListContractById", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async createOrUpdate(body: any) {
    const newBody = InquiryUpdateModel.assign(body)
    const res = await http.post(
      "api/services/app/Inquiry/CreateOrUpdate",
      newBody
    )
    return res.data.result
  }
  public async UpdateComplete(id: any) {
    const result = await http.put(
      "api/services/app/Inquiry/UpdateComplete",
      {},
      {
        params: { id },
      }
    )
    return result
  }
  public async UpdateDrop(params) {
    const result = await http.put(
      "api/services/app/Inquiry/UpdateDrop",
      {},
      { params: params }
    )
    return result
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Inquiry/Get", {
      params: { id },
    })
    return InquiryDetailModel.assign(res.data.result)
  }
  public async activateOrDeactivate(id: number, isActive) {
    const result = await http.post(
      "api/services/app/Inquiry/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification(L("CHANGE_STATUS_SUCCESSFULLY"))
    )
    return result.data
  }

  public async getAuditLogs(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetAuditLogs", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async getMatchingInquiry(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetMatchingInquiry", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async getSimpleInquiry(params: any) {
    const result = await http.get(
      "api/services/app/Inquiry/GetListInquiryForLA",
      { params }
    )
    return InquirySimpleModel.assigns(result.data?.result.items || [])
  }

  public async getDueDate(params: any): Promise<any> {
    const res = await http.get("/api/services/app/Inquiry/GetDueDate", {
      params,
    })
    const { result } = res.data

    return result
  }

  public async assignAgency(body: {
    ids: number[]
    agencyMasterId?: number | null
    consultantId?: number | null
  }) {
    const res = await http.post(
      "api/services/app/Inquiry/AssignAgency",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async convertToBooking(inquiryId: number) {
    // const res = await http.post(
    //   "api/services/app/Inquiry/ConvertToBooking",
    //   {},
    //   { params: { inquiryId } }
    // )
    // notifySuccess(
    //   LNotification("SUCCESS"),
    //   LNotification("SAVING_SUCCESSFULLY")
    // )
    // return res.data.result
  }
}

export default new InquiryService()
